import React, {useEffect} from 'react';
import {connect} from "react-redux";
import PicButton from "../../../../../../components/pic-button";
import Icon from "../../../../../../components/icon";
import Loader from "../../../../../../components/sprite/components/loader";
import ContactInfo from "./components/contact-info";
import ContactLabels from "./components/contact-labels";
import ContactSharedWith from "./components/contact-shared-with";
import ContactContent from "./components/contact-content";
import ContactEdit from "./components/contact-edit";
import {findContactDetails} from "../../../../../../../actions/contactDetailsActions";
import {findComments} from "../../../../../../../actions/commentActions";
import AddCollaboratorsPopup from "../add-collaborators-popup";
import {autoCompleteEnteredValue, resetAddedCollaborators, getSharingDetailsPopup} from '../../../../../../../actions/sharingDetailsActions';
import './index.css';

function ContactDetailsPopup (props) {

    const {
        findContactDetails,
        setFindContactDetails,
        setFindComments,
        contactDetailsEditMode,
        sharingDetailsPopup,
	    autoCompleteEnteredValue,
	    resetAddedCollaborators,
        selectedContactsGroup,
        sharingPageReady,
    } = props;

    useEffect(() => {
        if(Object.keys(props?.getContactCardDetails).length<1){
            setFindContactDetails(sharingDetailsPopup[2][0].id, sharingDetailsPopup[2][0].type);
            setFindComments(sharingDetailsPopup[2][0].id, 50);
        }
    }, [sharingDetailsPopup, setFindContactDetails, props.getContactCardDetails, setFindComments, selectedContactsGroup.id, props?.contactSearchResult?.contacts?.length, props?.searchResultValue, props?.selectedContactsGroup?.id]);

    useEffect(() => {
        if(Object.keys(props?.getContactCardDetails).length>1 && sharingPageReady){
            setFindContactDetails(sharingDetailsPopup[2][0].id, sharingDetailsPopup[2][0].type);
            setFindComments(sharingDetailsPopup[2][0].id, 50);
        }
    }, [sharingDetailsPopup, sharingPageReady, props.getContactCardDetails, setFindComments, setFindContactDetails]);

    const closeSharingSettings = () => {

	    autoCompleteEnteredValue("");
	    resetAddedCollaborators();

        if(document.querySelector('.slide.new-contact-details-popup')){
            document.querySelector('.slide.new-contact-details-popup').style.left = '0';
        }
    };

    if(findContactDetails){
        if(contactDetailsEditMode){
            return (
                <ContactEdit/>
            )
        } else {
            return (
                <div className="slide new-contact-details-popup overflow-hidden">
                    <div className="left-panel">
                        <ContactInfo
                            imageString={findContactDetails.imageString}
                            givenName={findContactDetails.phoneContactEntry.givenName}
                            middleName={findContactDetails.phoneContactEntry.middleName}
                            familyName={findContactDetails.phoneContactEntry.familyName}
                            jobTitle={findContactDetails.phoneContactEntry.jobTitle}
                            company={findContactDetails.phoneContactEntry.company}
                            department={findContactDetails.phoneContactEntry.department}
                            description={findContactDetails.phoneContactEntry.note}
                            phoneNumbers={findContactDetails.phoneContactEntry.phoneNumbers}
                            emailAddresses={findContactDetails.phoneContactEntry.emailAddresses}
                        />
                        <div className="d-flex align-items-start justify-content-between overflow-auto">
                            <ContactLabels
                                labels={findContactDetails.labels}
                            />
                            <ContactSharedWith/>
                        </div>
                        <ContactContent/>
                    </div>
                    <div className="right-panel">
                        <PicButton onClick={closeSharingSettings}>
                            <Icon name="long-arrow-left" />
                        </PicButton>
                        <AddCollaboratorsPopup/>
                    </div>
                </div>
            );
        }

    } else {
        return <Loader/>
    }
}

const mapStateToProps = (state) => {
    return {
        findContactDetails: state.contactDetailsReducer.findContactDetails,
        contactDetailsEditMode: state.contactReducer.contactDetailsEditMode,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
		checkGmailAddOnData:state.profileReducer.setGmailAddOnData,
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        getContactCardDetails: state.contactReducer.contactCardDetails,
        sharingPageReady: state.profileReducer.sharingPageReady
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFindContactDetails: (object, object2) => {
            dispatch(findContactDetails(object, object2))
        },
        setFindComments: (contactId, pageSize) => {
            dispatch(findComments(contactId, pageSize))
        },
	    autoCompleteEnteredValue: (string) => {
		    dispatch(autoCompleteEnteredValue(string))
	    },
        resetAddedCollaborators: () => {
		    dispatch(resetAddedCollaborators())
        },
        getSharingDetailsPopup: (array) => {
			dispatch(getSharingDetailsPopup(array));
		}
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetailsPopup);
